import slugify from 'slugify'
/**
 * Given a category and the current locale returns an href to the product list page.
 *
 * @param {Object} category
 * @returns {string}
 */
export const categoryUrlBuilder = (category) => {
    if (!category?.id) return ''

    return `/collections/${category?.id}`
}

/**
 * Given a product and the current locale returns an href to the product detail page.
 *
 * @param {Object} product
 * @returns {string}
 */
export const productUrlBuilder = (product) => {
    if (product?.productName) {
        const productName = slugify(product.productName, {
            lower: true, // Convert to lowercase
            strict: true, // Remove special characters
            trim: true // Remove leading/trailing hyphens
        })
        return `/products/${productName}-${product.productId}.html`
    }
}

/**
 * Extracts the product ID from a product slug
 * @param {string} slug - The product slug from the URL
 * @returns {string} The product ID
 */
export const extractProductId = (slug) => {
    if (slug.includes('-')) {
        return slug
            .replace(/\.html$/, '')
            .split('-')
            .pop()
    }

    return slug
}

export * from '@salesforce/retail-react-app/app/utils/url'
